<template>
  <div class="personInfoCard">
    <!-- 个人信息卡片 -->
    <div class="person-info-cont">
      <div class="person-info-left">
        <!-- 头像 -->
        <div class="person-head-cont"><img :src="`${userInfo.logoFileUrl||'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/userImage.png'}`"/></div>
        <!-- 信息 -->
        <div class="person-introduce-cont" v-if="personInfo.uCenterMemberInforDto">
          <p>
            <span>{{personInfo.uCenterMemberInforDto.trueName}}（{{personInfo.uCenterMemberInforDto.email}}），{{greetings}}</span>
            <!-- <el-button class="cyg-btn-cont">成为“诚意供”</el-button> -->
          </p>
          <p class="person-introduce-p1">

            <span class="mr15">{{personInfo.companyName}} </span>
            <span class="mr15">
                <span :key="item.id" v-for="(item,idx) in personInfo.details">{{item.detailName}} <i v-if="idx!=personInfo.details.length-1"> / </i></span>
              </span>
            <span class="mr15">
                <span :key="item.id" v-for="(item,idx) in personInfo.functions">{{item.functionName}} <i v-if="idx!=personInfo.functions.length-1"> / </i></span>
              </span>

            <span v-if="type==2&&personInfo.register" class="mr10"><img src="../../../assets/images/rz1.png"/></span>
            <el-popover
                    v-if="!personInfo.overDue&&type==2"
                    placement="top-start"
                    title="企业征信"
                    width="auto"
                    popper-class="person-popover"
                    trigger="hover">
              <div class="person-popover-cont">
                <el-button class="ckzx-btn-cont" @click="toPath2(personInfo.creditUrl)">查看征信报告</el-button>
                <ul>
                  <!-- {{personInfo.orgCreditInformation}} -->
                  <li :key="idx" v-for="(item,idx) in Object.keys(personInfo.map)"><span class="popover-span1">{{item}}</span><el-progress :stroke-width="8" class="person-progress" :percentage="personInfo.orgCreditInformation.newDataSign==2?Number(personInfo.map[item][0]):(Number(personInfo.map[item][0])/Number(personInfo.map[item][1])*100)" color="#65A0E6" :show-text="false"></el-progress><span>{{personInfo.map[item][0]}}/{{personInfo.orgCreditInformation.newDataSign==2?100:parseInt(personInfo.map[item][1])}}</span></li>
                  <!-- <li><span class="popover-span1">企业规模</span><el-progress :stroke-width="8" class="person-progress" :percentage="personInfo.orgCreditInformation.scalePercent*100"  color="#65A0E6" :show-text="false"></el-progress><span>{{personInfo.orgCreditInformation.scaleScore}}</span></li>
                  <li><span class="popover-span1">行业信息</span><el-progress :stroke-width="8" class="person-progress" :percentage="personInfo.orgCreditInformation.industryPercent*100"  color="#65A0E6" :show-text="false"></el-progress><span>{{personInfo.orgCreditInformation.industryScore}}</span></li>
                  <li><span class="popover-span1">公共记录</span><el-progress :stroke-width="8" class="person-progress" :percentage="personInfo.orgCreditInformation.popularPercent*100"  color="#65A0E6" :show-text="false"></el-progress><span>{{personInfo.orgCreditInformation.popularScore}}</span></li>
                  <li><span class="popover-span1">采招平台数据</span><el-progress :stroke-width="8" class="person-progress" :percentage="personInfo.orgCreditInformation.platformPercent*100"  color="#65A0E6" :show-text="false"></el-progress><span>{{personInfo.orgCreditInformation.platformScore}}</span></li> -->
                </ul>
                <div class="popover-time">数据更新时间：{{personInfo.orgCreditInformation.cardEffectTime}}</div>
              </div>
              <span class="rz2-cont mr10" slot="reference"><img style="width:62px" src="../../../assets/images/rzicon2.png"/><span class="rz-txt" v-if="personInfo.level">{{personInfo.level}}</span><span class="rz-txt" v-else style="font-size:10px">未评级</span></span>
            </el-popover>
            <!-- 禁用状态 -->
            <el-popover
                    v-if="personInfo.overDue&&type==2"
                    placement="top-start"
                    title=""
                    width="auto"
                    popper-class="person-popover"
                    trigger="hover">
              <div class="person-popover-cont person-popover-cont2">
                <span class="el-popover__title">企业征信</span><el-button @click="toPath('/supplierService')" class="cyg-btn-cont">成为“诚意供”</el-button>
              </div>
              <span class="rz2-cont mr10" slot="reference"><img style="width:62px" src="../../../assets/images/rzicon3.png"/><span class="rz-txt rz-txt2" v-if="personInfo.level">{{personInfo.level}}</span><span class="rz-txt rz-txt2" v-else style="font-size:10px">未评级</span></span>
            </el-popover>
            <span v-if="type==2&&personInfo.fosun" class="p1-tag">{{personInfo.levelName}}</span>
          </p>
          <p class="person-introduce-p2" v-if="type==2" :class="tagOpen?'active':''" id="tag">
            <span class="tag" :key="item.id" v-for="(item,idx) in tagData">{{item.serviceName}}</span>
            <span id="more" v-if="tagShow"  class="more"  :class="tagOpen?'more-active':''" @click="moreTag">{{tagOpen?'收起':'更多...'}}</span>
          </p>
        </div>
      </div>
      <!-- 分类按钮 -->
      <div class="person-info-right" v-if="type==2">
        <div class="tr"><el-button class="product-class-btn" @click="toPath2(personInfo.companyUrl)">维护产品服务分类</el-button></div>
        <div class="product-class-hint">有助于让采购商更经准的搜索到你</div>

        <el-button class="cyg-btn-cont" v-if="personInfo.stratAgreementUrl" @click="toPath2(personInfo.stratAgreementUrl)">战略协议填报</el-button>
      </div>

      <div class="person-info-right2" v-if="type==1">
        <el-button class="cyg-btn-cont" @click="showAwait()">我的仪表盘</el-button>
      </div>
    </div>
    <await-dialog
            title="我的仪表盘"
            :awaitShow="awaitShow"
            @initFuc="initFuc"
    ></await-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  import awaitDialog from './awaitDialog.vue'
  export default {
    // type 1为采购商 2为供应商，
    props: ['type','personInfo'],
    components: {
      "await-dialog": awaitDialog
    },
    data () {
      return {
        rzStatus:'1',
        dateNow:new Date(),
        greetings:'',//问候语
        timer:null,
        tagData:[],
        tagOpen:false,
        userInfo:{
          // logoFileUrl:''
        },
        tagShow:false,//更多是否显示
        awaitShow:false
      }
    },
    watch:{
      personInfo(){
        this.$set(this,'tagData',this.personInfo.service)
        if(this.type==2){
          this.setTagShow()
        }
        this.$nextTick(()=>{
          let tagWidth=document.getElementById("tag")?document.getElementById("tag").offsetWidth:0
          if(tagWidth>550){
            this.tagShow=true
          }else{
            this.tagShow=false
          }
        })
      }
    },
    mounted () {
      let userInfo = this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv) || "{}"
      this.userInfo = JSON.parse(userInfo)
      // console.log(this.userInfo )
      // console.info(this.userInfo,this.userInfo.logoFileUrl,'logoFileUrl')
      this.getGreetings()
    },
    beforeDestroy(){
      clearInterval(this.timer)
    },
    methods: {
      showAwait(){
        this.awaitShow=true
      },
      initFuc(){
        this.awaitShow=false
      },
      // 设置tag显示
      setTagShow(){
        let reduceNum=1//需要减少的标签
        let _evt=(num)=>{
          if(this.personInfo.service.length>1){

            this.$nextTick(()=>{
              // console.info(document.getElementById('more').offsetTop,"document.getElementById('more').offsetTop")
              if(document.getElementById('more').offsetTop!=0){
                this.$set(this,'tagData',this.personInfo.service.slice(0,num-reduceNum))
                reduceNum++
                this.$nextTick(()=>{
                  _evt(num)
                })
              }
            })
          }
        }
        this.$nextTick(()=>{
          let num=0
          let spanArr=document.getElementById('tag').getElementsByTagName('span')
          Array.prototype.forEach.call(spanArr,item=>{
            // console.info(item,item.offsetTop)
            if(item.offsetTop==0){
              num++
            }
          })
          if(!this.tagOpen){
            this.$set(this,'tagData',this.personInfo.service.slice(0,num))
            // this.$nextTick(()=>{
            //   // 如果更多不在第一行
            //   if(document.getElementById('more').offsetTop!=0){
            //     this.$set(this,'tagData',this.personInfo.service.slice(0,num-1))
            //     this.$nextTick(()=>{
            //       if(document.getElementById('more').offsetTop!=0){
            //         this.$set(this,'tagData',this.personInfo.service.slice(0,num-2))
            //       }
            //     })
            //   }
            // })
            _evt(num)
          }
        })
      },
      // 获取问候语
      getGreetings(){
        // 6：00 ~11：59：
        // #{用户姓名+邮箱}，上午好，祝你开心每一天！
        // 12：00~20：00：
        // #{用户姓名+邮箱}，下午好，工作累了喝杯咖啡提提神！
        // 20：00~6点（+1）：
        // #{用户姓名+邮箱}，夜已深，早点回家休息吧！
        this.timer=setInterval(()=>{

          let hour=new Date().getHours()
          if(hour>=6&&hour<12){
            this.greetings='上午好，祝你开心每一天！'
          }else if(hour>=12&&hour<20){
            this.greetings='下午好，工作累了喝杯咖啡提提神！'
          }else if((hour>=20&&hour<24)||(hour>=0&&hour<6)){
            this.greetings='夜已深，早点回家休息吧！'
          }
        },1000)
      },
      moreTag(){
        if(!this.tagOpen){
          this.$set(this,'tagData',this.personInfo.service.slice(0))
        }else{
          this.setTagShow()
        }
        this.tagOpen=!this.tagOpen
      },
      toPath(url,params={}){
        let routeData = this.$router.resolve({
          path: url,
          query:params
        });
        window.open(routeData.href, '_blank');
      },
      toPath2(url){
        window.open(url,'_blank')
      }
    },
    computed:{
      ...mapState([
        'KP'
      ]),
      getNowDate(){
        let val=new Date()
        let dateMat = new Date(val);
        let year = dateMat.getFullYear();
        let month =
          dateMat.getMonth() > 8
            ? dateMat.getMonth() + 1
            : "0" + (dateMat.getMonth() + 1);
        let day =
          dateMat.getDate() < 10 ? "0" + dateMat.getDate() : dateMat.getDate();
        let timeFormat = year + "-" + month + "-" + day;
        return timeFormat;
      }
    }
  }
</script>

<style>
  .person-head-cont img{
    height: 60px;
    width: 60px;
    border-radius: 100%;
    border: 1px solid #F0F2F5;
  }
  .personInfoCard .tr{
    text-align: right;
  }
  .personInfoCard .mr15{
    margin-right: 15px;
  }
  .personInfoCard .mr10{
    margin-right: 10px;
  }
  .personInfoCard .person-info-cont{
    padding:20px 15px 15px 30px;
    background: #FFFFFF;
    border-radius: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
  }
  .personInfoCard .person-info-left{
    display: flex;
    width: 80%;
  }
  .personInfoCard .person-introduce-cont{
    padding-left:15px
  }
  .personInfoCard .person-info-right {
    position: relative;
    width: 19%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .personInfoCard .person-info-right2{
    width: 19%;
    padding-right: 15px;
    display: flex;
    justify-content: flex-end;
  }
  .personInfoCard .person-info-right .product-class-btn{
    background: #F2F8FF;
    border: 1px solid #90BCF2;
    border-radius: 3px;
    border-radius: 3px;
    color:#2E8AF1;
    font-size: 12px;
    line-height: 22px;
    height: 24px;
    padding: 0 10px;
    margin-bottom: 5px;
  }
  .personInfoCard .person-info-right .cyg-btn-cont{

    position: absolute;
    right:0;
    top:0px;
    background: #2E8AF1;
    border-radius: 3px;
    border-radius: 3px;
    font-size: 12px;
    color: #FFFFFF;
    line-height:22px;
    padding: 0 10px;
    height: 24px;
    border-color: #2E8AF1;
  }
  .personInfoCard .person-info-right .product-class-hint{
    text-align: right;
    font-size: 12px;
    color: #909399;
    letter-spacing: 0;
    line-height: 18px;
  }
  .personInfoCard .person-info-left{
    font-size: 16px;
    color: #303133;
    text-align: left;
    line-height: 24px;
  }
  .personInfoCard .person-info-left .cyg-btn-cont,.personInfoCard .person-info-right2 .cyg-btn-cont{
    margin-left: 15px;
    background: #2E8AF1;
    border-radius: 3px;
    border-radius: 3px;
    font-size: 12px;
    color: #FFFFFF;
    line-height:22px;
    padding: 0 10px;
    height: 24px;
    border-color: #2E8AF1;
  }
  .personInfoCard .person-info-left .person-introduce-p1{
    font-size: 12px;
    color: #909399;
    line-height: 18px;
  }
  .personInfoCard .person-info-left .person-introduce-p2{
    /* height: 24px; */
    overflow: hidden;
    /* padding-right: 44px; */
    position: relative;
  }

  .personInfoCard .person-info-left .person-introduce-p2::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  .personInfoCard .person-info-left .person-introduce-p2::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }

  .personInfoCard .person-info-left .person-introduce-p2::-webkit-scrollbar-thumb {
    -webkit-border-radius: 4px;
    border-radius: 4px;
    background: rgba(0,0,0,0.3);
  }

  .personInfoCard .person-info-left .person-introduce-p2::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0,0,0,0.2);
  }
  .personInfoCard .person-info-left .person-introduce-p2.active{

    max-height: 114px;
    min-height: 34px;
    overflow: auto;
    padding-right: 0;
  }
  .personInfoCard .person-info-left .person-introduce-p2 .tag{
    background: #F0F2F5;
    border-radius: 3px;
    border-radius: 3px;
    display: inline-block;
    vertical-align: middle;
    font-size: 12px;
    color: #606266;
    text-align: left;
    line-height: 18px;
    padding: 3px 12px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .personInfoCard .person-info-left .person-introduce-p2 .more{
    /* position: absolute;
    right: 0;
    top:0; */
    font-size: 12px;
    color: #2E8AF1;
    line-height: 18px;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    line-height: 18px;
    padding: 3px 0;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .personInfoCard .person-info-left .person-introduce-p2 .more:hover{
    cursor: pointer;
  }
  .personInfoCard .person-info-left .person-introduce-p2 .more.more-active{
    position: relative;
  }
  .personInfoCard .person-introduce-p1 .p1-tag{
    display: inline-block;
    vertical-align: middle;
    background: #EE8D8C;
    border-radius: 3px;
    border-radius: 3px;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 18px;
    padding:0 5px;
  }
  .personInfoCard .rz2-cont{
    position: relative;
  }
  .personInfoCard .rz-txt{
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height: 100%;
    padding-left: 22px;
    font-size: 12px;
    color: #E49436;
    text-align: center;
    line-height: 18px;
  }
  .personInfoCard .rz-txt2{
    color: #C4C8CE;
  }
  .person-popover-cont .mb15{
    margin-bottom: 15px;
  }
  .person-popover-cont{
    position: relative;
    color:#303133;
  }
  .person-popover-cont2{
    display: flex;
    justify-content: space-between;
  }
  .person-popover-cont2 .cyg-btn-cont{
    margin-left: 15px;
    background: #2E8AF1;
    border-radius: 3px;
    border-radius: 3px;
    font-size: 12px;
    color: #FFFFFF;
    line-height:22px;
    padding: 0 10px;
    height: 24px;
    border-color: #2E8AF1;
  }
  .person-popover-cont li{
    margin-bottom: 15px;
  }
  .person-popover .el-popover__title{
    font-size: 14px;
    margin-bottom: 10px;
    color:#303133;
    font-weight: bold;
  }
  .person-popover-cont2 .el-popover__title{
    line-height: 24px;
    margin-bottom: 0;
  }
  .person-popover-cont .ckzx-btn-cont{
    position: absolute;
    right:0;
    top:-28px;
    background: #2E8AF1;
    border-radius: 3px;
    border-radius: 3px;
    font-size: 12px;
    color: #FFFFFF;
    line-height:22px;
    padding: 0 10px;
    height: 24px;
    border-color: #2E8AF1;
  }
  .person-progress{
    width:200px;
    display:inline-block;
    margin: 0 10px;
    vertical-align: middle;
  }
  .popover-span1{
    width:75px;
    display:inline-block;
    vertical-align: middle;
    text-align: right;
    font-size: 12px;
  }
  .popover-time{
    text-align: right;
    font-size: 12px;
    color: #C4C8CE;
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/personInfoCard.vue